//import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
//import { API_BASE_URL } from '../constants';

import { apiSlice } from '../app/api/apiSlice';

export const jobsApi = apiSlice.injectEndpoints({
  tagTypes: ['Jobs'],
  endpoints: (builder)=>({
    jobs: builder.query({
      keepUnusedDataFor: 0,
      query: (query="") => `jobs${query}`,
      providesTags: ['Jobs']
    }),
    jobsForUser: builder.query({
      keepUnusedDataFor: 0,
      query: (query) => `jobs/jobsForUser`
    }),
    coolDown: builder.query({
      keepUnusedDataFor: 0,
      query: (query) => `cooldown`
    }),
    job: builder.query({
      query: (jobId) => `jobs?id=${jobId}` ,
      keepUnusedDataFor: 0,
      providesTags: ['Jobs']
    }),
    requestType: builder.query({
      query: () => `jobs/request-type` ,
      providesTags: ['RequestTypes']
    }),
    claimJob: builder.mutation({
      query: ({jobId, userId}) => ({
        url: "jobs/claim",
        method: "POST",
        body: {jobId:jobId, encoreHiveUserId: userId}
      })
    }),
    jobEdit: builder.mutation({
      query: ({job, userId}) => ({
        url: "Jobs/edit?userId=" + userId,
        method: "PUT",
        body: job
      })
    }),
    getJobByIdFromApi: builder.query({
      query: (query) => "Jobs/" + query
    }),
    hardEscalate: builder.mutation({
      query: (body) => ({
        url: "Jobs/hard-escalate",
        method: "POST",
        body: body
      })
    }),
    escalate: builder.mutation({
      query: (body) => ({
        url: "Jobs/Escalate",
        method: "POST",
        body: body
      })
    }),
    resolveEscalationApi: builder.mutation({
      query: (body) => ({
        url: "Jobs/ResolveEscalation",
        method: "POST",
        body: body
      })
    }),
    getEscalations: builder.query({
      query: (query) => query ? `Jobs/GetEscalations?jobId=${query}` : "Jobs/GetEscalations",
    }),
    escalationClaim: builder.mutation({
      query: ({escalationId, adminId}) => ({
        url: "Jobs/escalate",
        method: "PUT",
        body: {
          id: escalationId,
          IssueResolvedSTNUserID: adminId,
        }
      })
    }),
    getEscalationReasons: builder.query({
      query: () => "Jobs/jobEscalationReasons"
    }),
    deleteJob: builder.mutation({
      query: (body) => ({
        url: `jobs/${body.jobId}`,
        body: body,
        method: 'DELETE'
      }),
      invalidatesTags: ['Jobs']
    }),
    getEscalationMainReasonSubReason: builder.query({
      query: () => 'Jobs/GetEscalationMainReasonSubReason', 
    }),
  })
})


// use the above api because it has the token inherithed by apiSlice

// export const jobsApi = createApi({
//   reducerPath: "jobsApi",
//   baseQuery: fetchBaseQuery({
//     baseUrl: API_BASE_URL + "Jobs",
//     prepareHeaders: (headers, { getState }) => {
//       // By default, if we have a token in the store, let's use that for authenticated requests
//       const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEyIiwibmJmIjoxNjYxNDQ4NTQzLCJleHAiOjE2NjE0NTU3NDMsImlhdCI6MTY2MTQ0ODU0M30.Uxp826ti3N6nAr3Sbdds_Lcq51rDezHCtC_A-2CmdJw"
//       if (token) {
//         headers.set('authorization', `Bearer ${token}`)
//       }
//       return headers
//     },
//   }),
//   endpoints: (builder)=>({
//     jobs: builder.query({
//       query: () => "?pageSize=0"
//     }),
//     job: builder.query({
//       query: (jobId) => `?id=${jobId}` 
//     })
//   })
// });

export const { useJobsQuery, useLazyJobsQuery, useJobQuery, useLazyJobQuery, useCoolDownQuery, useLazyJobsForUserQuery, useRequestTypeQuery, useClaimJobMutation, useJobEditMutation, useLazyGetJobByIdFromApiQuery, useResolveEscalationApiMutation, useLazyGetEscalationsQuery, useEscalationClaimMutation, useLazyGetEscalationReasonsQuery, useGetEscalationReasonsQuery, useHardEscalateMutation, useEscalateMutation, getJobByIdFromApiQuery, useDeleteJobMutation, useGetEscalationMainReasonSubReasonQuery } = jobsApi;
